<template>
   <div>
      <main class="fix">
         <section class="breadcrumb__area breadcrumb__bg">
            <div class="bg-img position-absolute top-0 bottom-0 start-0 w-100 h-100"
               :style="{ backgroundImage: `url('assets/img/banner/banner1.png')` }"></div>
            <div class="container">
               <div class="row">
                  <div class="col-lg-12">
                     <div class="breadcrumb__content">
                        <h2 class="title">Produk Hukum</h2>
                        <nav aria-label="breadcrumb">
                           <ol class="breadcrumb">
                              <li class="breadcrumb-item"><a href="javascript:void(0);"
                                    @click="$router.push('/')">Beranda</a></li>
                              <li class="breadcrumb-item active" aria-current="page">Produk Hukum</li>
                           </ol>
                        </nav>
                     </div>
                  </div>
               </div>
            </div>
            <div class="breadcrumb__shape">
               <img src="assets/img/images/breadcrumb_shape01.png" alt="Apexa" class="dark-opacity" />
               <img src="assets/img/images/breadcrumb_shape02.png" alt="Apexa" class="rightToLeft dark-opacity" />
               <img src="assets/img/images/breadcrumb_shape03.png" alt="Apexa" class="dark-opacity" />
               <img src="assets/img/images/breadcrumb_shape04.png" alt="Apexa" class="dark-opacity" />
               <img src="assets/img/images/breadcrumb_shape05.png" alt="Apexa" class="alltuchtopdown dark-opacity" />
            </div>
         </section>

         <section class="blog_area mt-5">
            <div class="container">
               <div class="row pb-40">
                  <div class="blog-post-wrap">
                     <div class="sidebar__widget sidebar__widget-two">
                        <div class="sidebar__search">
                           <form action="#">
                              <input type="text" v-model="cari_value" @keyup="cari_data()" placeholder="Cari Data" />
                              <button type="button" style="cursor: default;">
                                 <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
                                    <path
                                       d="M19.0002 19.0002L14.6572 14.6572M14.6572 14.6572C15.4001 13.9143 15.9894 13.0324 16.3914 12.0618C16.7935 11.0911 17.0004 10.0508 17.0004 9.00021C17.0004 7.9496 16.7935 6.90929 16.3914 5.93866C15.9894 4.96803 15.4001 4.08609 14.6572 3.34321C13.9143 2.60032 13.0324 2.01103 12.0618 1.60898C11.0911 1.20693 10.0508 1 9.00021 1C7.9496 1 6.90929 1.20693 5.93866 1.60898C4.96803 2.01103 4.08609 2.60032 3.34321 3.34321C1.84288 4.84354 1 6.87842 1 9.00021C1 11.122 1.84288 13.1569 3.34321 14.6572C4.84354 16.1575 6.87842 17.0004 9.00021 17.0004C11.122 17.0004 13.1569 16.1575 14.6572 14.6572Z"
                                       stroke="currentcolor" stroke-width="2" stroke-linecap="round"
                                       stroke-linejoin="round" />
                                 </svg>
                              </button>
                           </form>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="row gutter-24 justify-content-center">
                  <div class="col-lg-12" v-for="data in list_data" :key="data.id">
                     <div class="features__item-two">
                        <div class="features__icon-two">
                           <img src="assets/img/pdf.png" alt="">
                        </div>
                        <div class="features__content-two">
                           <h4 class="title mt-4"><a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#exampleModal" @click="selectData(data)">{{ data.judul }}</a></h4>
                        </div>
                     </div>
                  </div>
               </div>

               <div class="pagination-wrap mt-40 mb-5">
                  <nav aria-label="Page navigation example">
                     <ul class="pagination list-wrap">
                        <!-- Prev -->
                        <li class="page-item" :class="{ disabled: page_first === 1 }"><a class="page-link" href="javascript:void(0);" @click="btn_prev"><i class="fas fa-angle-double-left"></i></a></li>

                        <!-- Loop halaman -->
                        <li v-for="page in pagesToShow" :key="'page_' + page" class="page-item" :class="{ active: page === page_first, disabled: page === '...' }">
                           <a v-if="page !== '...'" class="page-link" href="javascript:void(0);" @click="goToPage(page)">
                              {{ page }}
                           </a>
                           <span v-else class="page-link">...</span>
                        </li>

                        <!-- Next -->
                        <li class="page-item" :class="{ disabled: page_first === page_last }"><a class="page-link" href="javascript:void(0);" @click="btn_next"><i class="fas fa-angle-double-right"></i></a></li>
                     </ul>
                  </nav>
               </div>

               <div class="modal fade" id="exampleModal" tabindex="-1" aria-hidden="true">
                  <div class="modal-dialog modal-lg">
                     <div class="modal-content">
                        <div class="modal-header">
                           <h5 class="modal-title">Lampiran</h5>
                           <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                           <iframe :src="file_path + form.file" width="100%" height="680px"></iframe>
                        </div>
                        <div class="modal-footer">
                           <button type="button" class="blog__post-tag-two" data-bs-dismiss="modal">Keluar</button>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </main>
   </div>
</template>

<script>
import UMUM from '../../library/umum'

export default {

   data() {
      return {
         data_load: false,
         form: {
            id: '',
            judul: '',
            sumber: '',
            deskripsi: '',
            uraian: '',
            foto: '',
            unit_kerja: '',
            status: '',
            keterangan: '',
         },

         id: '',
         file_path: this.$store.state.url.URL_APP + "uploads/",
         UMUM: UMUM,

         list_data: [],
         page_first: 1,
         page_last: 0,
         max_visible: 5,
         cari_value: "",
         kategori: "PERBUP",
      }
   },
   methods: {
      getView: function () {
         fetch(this.$store.state.url.URL_PRODUK_HUKUM + "view", {
            method: "POST",
            headers: {
               "content-type": "application/json",
            },
            body: JSON.stringify({
               data_ke: this.page_first,
               cari_value: this.cari_value,
               kategori: this.kategori,
            })
         })
            .then(res => res.json())
            .then(res_data => {
               this.list_data = res_data.data;
               this.page_last = res_data.jml_data;
               // console.log(res_data);

            });
      },

      selectData: function (data) {
         this.form = {
            id: data.id,
            judul: data.judul,
            file: data.file,
         };
      },

      btn_prev: function () {
         if (this.page_first > 1) {
            this.page_first--
         } else {
            this.page_first = 1;
         }
         this.getView();
      },

      btn_next: function () {

         if (this.page_first >= this.page_last) {
            this.page_first == this.page_last
         } else {
            this.page_first++;
         }
         this.getView();
      },

      goToPage(page) {
         if (page === '...') return;
         this.page_first = page;
         this.getView();
      },

      cari_data: function () {

         this.page_first = 1;
         this.getView();
      },
      // ================== PAGINASI ====================
   },
   // =============================================================== METHODS =========================================================================

   computed: {
      pagesToShow() {
         const pages = [];
         const total = this.page_last;
         const current = this.page_first;
         const max = this.max_visible;

         if (total <= max) {
            for (let i = 1; i <= total; i++) pages.push(i);
         } else {
            pages.push(1);

            if (current > 3) pages.push("...");

            const start = Math.max(2, current - 1);
            const end = Math.min(total - 1, current + 1);

            for (let i = start; i <= end; i++) pages.push(i);

            if (current < total - 2) pages.push("...");

            pages.push(total);
         }

         return pages;
      },
   },

   mounted() {

      this.getView();

   }
};
</script>

<style></style>